import './videoSec.css';
import Slider from "react-slick";
import TelematicsVideoPlayer from "../videoTelematicsComponent/telematicsVideoPlayer/telematicsVideoPlayer";
import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {videos} from "../../data/videosData";
import UtilityService from "../../services/utility.service";
import {format} from "date-fns";
import Video from "../../shared/video/video";
import VideoPlayer from "../../shared/videoPlayer/videoPlayer";
import Placeholder from "../../shared/placeholder/placeholder";

const VideoSec = (
    {
        alerts,
        tripId = '',
        isDVR = false,
        onVideoClick = () => {},
        loader = false,
        selectedAlert
    }, ref) => {

    const [showVideoPlayer, setShowVideoPlayer] = useState(false);
    const [videoIndex, setVideoIndex] = useState(0);
    const [highlightVideo, setHighlightVideo] = useState(false);
    const slickRef = useRef();
    const [videoPlayerData, setVideoPlayerData] = useState({
        player: {},
        other: {}
    });

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
    };

    const handleShowVideoPlayer = (val, index, videoData, alertData) => {
        setShowVideoPlayer(val);
        setVideoIndex(+index);
        setVideoPlayerData((prevState) => {
            return {
                ...prevState,
                player: videoData,
                other: alertData
            }
        });
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    const showSelectedAlertVideo = () => {
        const index = alerts.findIndex((alert) => alert?.externalAlertId === selectedAlert?.externalAlertId);
        if (index >= 0 && selectedAlert?.isVideoAvailable)
        {
            slickRef.current.slickGoTo(index - 1);
            setHighlightVideo(true);
            const highlightTimer = setTimeout(() => {
                setHighlightVideo(false);
                clearTimeout(highlightTimer);
            }, 5000);
        }
    }

    useEffect(() => {
        if (selectedAlert) {
            showSelectedAlertVideo();
        }
    }, [selectedAlert]);


    return (
        <>
            {loader &&
                <ul className={'coaching-videos-sec grid col-3 gap-5 video-place-holder'}>
                    {[1, 2, 3].map(v =>
                        <li key={v} className={`slide-box`}>
                            <div className={`content`}>
                                <div className="margin-b-20">
                                    <Placeholder height={'220px'}/>
                                </div>
                                <div className="">
                                    <Placeholder height={'25px'}/>
                                </div>
                            </div>
                        </li>
                    )}
                </ul>
            }

            {alerts && !loader &&
                <ul className={'coaching-videos-sec page-fade-in'}>
                    <Slider  {...settings} ref={slickRef}>
                        {alerts?.map((alert, index) =>
                            alert?.isVideoAvailable &&
                            <li className={`slide-box ${isDVR ? 'not-seen' : ''} `}
                                key={alert?.externalAlertId}>
                                <div className={`content ${alert?.externalAlertId === selectedAlert?.externalAlertId && highlightVideo ? 'highlight' : ''}`}>
                                    <div className="width-block-100 video-thumb black-back margin-b-20 cursor-pointer ">
                                        <Video tripId={tripId}
                                               videoId={alert?.externalAlertId}
                                               alertData={alert}
                                               onClick={onVideoClick}/>
                                    </div>
                                    <div className="coaching-videos-details sf-medium font-14 flex gap-10">
                                        <div className={`rating-box ${alert?.alertType}`}>
                                            {UtilityService.getAlertName(alert?.alertType)}
                                        </div>
                                        <ul className={'separator gap-20'}>
                                            <li>
                                                <span className={'margin-r-5'}>
                                                    {format(new Date(`${alert?.startTimeInISO}`), 'hh:mm')}
                                                </span>
                                                <span>
                                                    {format(new Date(`${alert?.startTimeInISO}`), 'dd MMM yyyy')}
                                                </span>
                                            </li>
                                            <li> Driver: <span className={'highlight-color'}>Babu K</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        )}

                    </Slider>
                </ul>
            }
            {!alerts &&
                <ul className={'coaching-videos-sec'}>
                    <Slider  {...settings}>
                        {videos.map((video, index) =>
                            <li className={`slide-box ${isDVR ? 'not-seen' : ''}`} key={index}
                                onClick={e => handleShowVideoPlayer(true, index)}>
                                <div className="content">
                                    <div className="icon width-block-100 margin-b-20">
                                        <img src={video.img} alt=""/>
                                    </div>
                                    <div className="coaching-videos-details sf-medium font-14 flex gap-10">
                                        <div className="rating-box red-box">{video.tag}</div>
                                        <ul className={'separator gap-20'}>
                                            <li><span className={'margin-r-5'}>19:27</span> 15 Sep 2023</li>
                                            <li> Driver: <span className={'highlight-color'}>Babu K</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        )}

                    </Slider>
                </ul>
            }

            {/*..... telematics video player ......*/}
            {/*{showVideoPlayer && alerts.length > 0 &&*/}
            {/*    <VideoPlayer videoData={videoPlayerData} handleShowVideoPlayer={handleShowVideoPlayer}/>*/}
            {/*}*/}
            {showVideoPlayer && !alerts &&
                <TelematicsVideoPlayer handleShowVideoPlayer={handleShowVideoPlayer}/>
            }
        </>
    )
}
export default forwardRef(VideoSec);
